import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Mail, ArrowUpRight } from "lucide-react";
import { SITE } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#002A5C] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center justify-center w-11 h-11 bg-[#FFC72C] text-[#003F88] font-serif-display text-2xl font-semibold leading-none">
              R
            </span>
            <div className="leading-tight">
              <div className="font-serif-display text-2xl">Antônio Rosalvo</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-white/60">
                {SITE.party} · {SITE.city}
              </div>
            </div>
          </div>
          <p className="text-white/70 font-light leading-relaxed max-w-md">
            Procurador Municipal concursado. Três mandatos como vereador e três passagens pela
            presidência da Câmara. Ex-Secretário da SEDUR. Cidadão laurofreitense a serviço do
            interesse público.
          </p>
          <a
            href={`https://wa.me/${SITE.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp"
            className="mt-8 inline-flex items-center gap-3 border border-white/30 text-white px-5 py-3 text-xs uppercase tracking-[0.2em] hover:bg-white hover:text-[#003F88] transition-colors"
          >
            <MessageCircle size={14} /> {SITE.whatsappDisplay}
          </a>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#FFC72C] mb-5">Navegação</div>
          <ul className="space-y-3 text-sm text-white/85">
            <li><Link to="/" className="hover:text-[#FFC72C] transition-colors">Início</Link></li>
            <li><Link to="/trajetoria" className="hover:text-[#FFC72C] transition-colors">Trajetória</Link></li>
            <li><Link to="/projetos" className="hover:text-[#FFC72C] transition-colors">Projetos</Link></li>
            <li><Link to="/plano-de-governo" className="hover:text-[#FFC72C] transition-colors">Plano de Governo</Link></li>
            <li><Link to="/vitrine" className="hover:text-[#FFC72C] transition-colors">Vitrine</Link></li>
            <li><Link to="/noticias" className="hover:text-[#FFC72C] transition-colors">Notícias</Link></li>
            <li><Link to="/contato" className="hover:text-[#FFC72C] transition-colors">Contato</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#FFC72C] mb-5">Conecte-se</div>
          <div className="space-y-3 text-sm text-white/85">
            <a href={SITE.instagram} target="_blank" rel="noreferrer" className="flex items-center justify-between border-b border-white/15 pb-3 hover:text-[#FFC72C] group" data-testid="footer-instagram">
              <span className="inline-flex items-center gap-3"><Instagram size={16} /> {SITE.instagramHandle}</span>
              <ArrowUpRight size={14} className="opacity-50 group-hover:opacity-100" />
            </a>
            <a href={SITE.facebook} target="_blank" rel="noreferrer" className="flex items-center justify-between border-b border-white/15 pb-3 hover:text-[#FFC72C] group" data-testid="footer-facebook">
              <span className="inline-flex items-center gap-3"><Facebook size={16} /> antoniorosalvo</span>
              <ArrowUpRight size={14} className="opacity-50 group-hover:opacity-100" />
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center justify-between border-b border-white/15 pb-3 hover:text-[#FFC72C] group" data-testid="footer-email">
              <span className="inline-flex items-center gap-3"><Mail size={16} /> {SITE.email}</span>
              <ArrowUpRight size={14} className="opacity-50 group-hover:opacity-100" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {SITE.name}. Todos os direitos reservados.</div>
          <div className="flex items-center gap-4">
            <span>{SITE.domain}</span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white/80">
              Acesso interno
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
